// extracted by mini-css-extract-plugin
export default {"toolbar":"dDmm6U","actions":"Mjul3w","action":"w3i2cf"};